import * as RBConstants from "./RBConstants";
import AppService from "Global/AppService";

const addDeviceToRBReducerState = (instanceId) => {
  return {
    type: RBConstants.RB_DATA_STATE_ADD,
    payload: instanceId,
  };
};

const removeDeviceToRBReducerState = (instanceId) => {
  return {
    type: RBConstants.RB_DATA_STATE_REMOVE,
    payload: instanceId,
  };
};

const getRBData = (url, payload, deviceId) => {
  return (dispatch) => {
    dispatch({ type: RBConstants.RB_DATA_FETCHING, payload: deviceId });

    function callback(success, err) {
      if (success && success.result) {
        dispatch(getRBDataSuccess(success, deviceId));
      } else {
        dispatch(getRBDataFailure(deviceId));
      }
    }
    AppService.postData(payload, url, callback);
  };
};

const getRBTestName = (url, payload, deviceId) => {
  return (dispatch) => {
    dispatch({ type: RBConstants.RB_TEST_NAME_FETCHING, payload: deviceId });

    function callback(success, err) {
      if (success && success.result) {
        dispatch(getRBTestNameSuccess(success, deviceId));
      } else {
        dispatch(getRBDataFailure(deviceId));
      }
    }
    AppService.postData(payload, url, callback);
  };
};

const getRBTestNameSuccess = (successResponse, deviceId) => {
  return {
    type: RBConstants.RB_TEST_NAME_FETCHED,
    payload: { newState: successResponse, deviceId: deviceId },
  };
};

const getRBTestNameFailure = (deviceId) => {
  return {
    type: RBConstants.RB_TEST_NAME_FETCHING_FAILED,
    payload: deviceId,
  };
};

const getRBDataSuccess = (successResponse, deviceId) => {
  return {
    type: RBConstants.RB_DATA_FETCHED,
    payload: { newState: successResponse, deviceId: deviceId },
  };
};

const getRBDataFailure = (deviceId) => {
  return {
    type: RBConstants.RB_DATA_FETCHING_FAILED,
    payload: deviceId,
  };
};

const getRBConfig = (url,deviceId) => {
	
	return (dispatch) => {
		dispatch({ type: RBConstants.RB_CONFIG_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success && success.result) {
				dispatch(getRBConfigSuccess(success,deviceId));
			} else {
				dispatch(getRBConfigFailure(deviceId));
			}
		}

		AppService.getData(url, callback);
	}
}

const getRBConfigSuccess = (successResponse,deviceId) => {
	return { type: RBConstants.RB_CONFIG_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getRBConfigFailure = (deviceId) => {
	return { type: RBConstants.RB_CONFIG_FAILED,payload:deviceId };
}


export {
  getRBData,
  getRBTestName,
  getRBDataSuccess,
  getRBDataFailure,
  getRBTestNameSuccess,
  getRBTestNameFailure,
  addDeviceToRBReducerState,
  removeDeviceToRBReducerState,
  getRBConfig,
  getRBConfigFailure,
  getRBConfigSuccess
};
